import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { OLTManagementPage } from '@/features/devices'

export const Route = createFileRoute('/_authenticated/devices/olts')({
  component: () => (
    <RequirePermission permission='olts.read'>
      <OLTManagementPage />
    </RequirePermission>
  ),
})
